import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Grid, IconButton, makeStyles, Tooltip, Typography } from "@material-ui/core";
import toast from "react-hot-toast";
import { CheckCircle, Close, Error, Info, Warning } from "@material-ui/icons";
import CopyToClipboard from "react-copy-to-clipboard";
import { useTranslation } from "react-i18next";

const getColor = (messageType) => {
  switch (messageType) {
    case "success":
      return "green";
    case "warning":
      return "rgb(250,218,94)";
    case "error":
      return "red";
    default:
      return "green";
  }
};

const getIcon = (messageType, classes) => {
  switch (messageType) {
    case "success":
      return <CheckCircle className={classes.iconMessage} />;
    case "warning":
      return <Warning className={classes.iconMessage} />;
    case "error":
      return <Error className={classes.iconMessage} />;
    default:
      return <Info className={classes.iconMessage} />;
  }
};

const useStyles = makeStyles(() => ({
  closeBtn: { color: "#666666" },
  iconMessage: (props) => {
    return {
      color: getColor(props.messageType),
      verticalAlign: "middle",
    };
  },
  messageText: {
    color: "#000000",
    margin: "0 10px 0 10px",
    overflow: "hidden",
    display: "-webkit-box",
    "-webkit-line-clamp": "7",
    "-webkit-box-orient": "vertical",
    background: "#F9F9F9",
    maxWidth: 395,
    whiteSpace: "pre-line",
    "&:hover": {
      overflow: "auto",
      maxHeight: "unset",
      "-webkit-line-clamp": "unset",
    },
  },
  guid: {
    textAlign: "right",
    color: "rgb(128,128,128)",
    width: "100%",
    paddingTop: 5,
    "&:hover, &:active": {
      fontWeight: "bold",
      textDecoration: "underline",
      cursor: "pointer",
    },
  },
}));

const Toast = (props) => {
  const {
    toast: {
      id,
      message: { message, type, correlationId },
    },
  } = props;
  const classes = useStyles({ messageType: type });
  const { t } = useTranslation();

  const handleClose = useCallback(() => {
    toast.dismiss(id);
  }, [id]);

  return (
    <Grid container alignItems="center" justifyContent="space-between">
      <Grid item>{getIcon(type, classes)}</Grid>
      <Grid item xs container>
        <Grid item xs={12}>
          <Typography variant="body2" className={classes.messageText}>
            {message}
          </Typography>
        </Grid>
        {correlationId && (
          <Grid item xs={12}>
            <CopyToClipboard text={correlationId}>
              <Tooltip title={t("General.ClickToCopy")}>
                <Typography variant="h6" component="div" className={classes.guid}>
                  {correlationId}
                </Typography>
              </Tooltip>
            </CopyToClipboard>
          </Grid>
        )}
      </Grid>
      <Grid item>
        <IconButton id="close_toast" onClick={handleClose} size="small" className={classes.closeBtn}>
          <Close />
        </IconButton>
      </Grid>
    </Grid>
  );
};

Toast.propTypes = {
  toast: PropTypes.object.isRequired,
};

export default Toast;
